module.exports = __webpack_public_path__ + "static/img/callback3.fa0f49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callback/callback3.png
// module id = SLzv
// module chunks = 0